import { render, staticRenderFns } from "./OpenCasesDialog.vue?vue&type=template&id=264172db&scoped=true&"
import script from "./OpenCasesDialog.vue?vue&type=script&lang=ts&"
export * from "./OpenCasesDialog.vue?vue&type=script&lang=ts&"
import style0 from "@/modules/Account/styles/open-cases-dialog.scss?vue&type=style&index=0&id=264172db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264172db",
  null
  
)

export default component.exports